import axios from "axios"
import { useState, useEffect } from "react"

const useFetchGet = (url) => {
    const [data, setData] = useState()
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState(null)

    useEffect(() => {
        const controller = new AbortController()
        const fetchData = () => {
            const signal = controller.signal
            axios.get(url, {signal})
            .then(res => res.data)
            .then(res => {
                setData(res)
                setIsLoading(false)
            })
            .catch((e) => setError(e))
        }
    if(url) {
        setIsLoading(true)
        setData()
        fetchData()
    } 
    return () => {
        controller.abort()
        setIsLoading(false)
    }
    },[url])

    return { error, isLoading, data }
}

export default useFetchGet